import React, { useEffect, useState } from "react";
import { Menu, Sun, Moon, ChevronRight } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import logo1 from "../assets/DOR white.png";
import logo2 from "../assets/DOR black.png";

function Header({
  theme,
  toggleTheme,
  scrolled,
  isMobileMenuOpen,
  toggleMobileMenu,
  setShowEarnModal
}) {
  const navigate = useNavigate();

const [selectedStore, setSelectedStore] = useState("");

useEffect(() => {
  const updateStore = () => {
    const store = localStorage.getItem("selectedStore");

    setSelectedStore(store || "");
  };

  // initial load
  updateStore();

  // custom event listener
  window.addEventListener("storeChanged", updateStore);

  return () => {
    window.removeEventListener("storeChanged", updateStore);
  };
}, []);

const handleChangeStore = () => {
  localStorage.removeItem("selectedStore");

  setSelectedStore("");

  navigate("/");

  // open modal instantly
  window.dispatchEvent(new Event("openStoreModal"));
};
  return (
    <>
      <header className={`header ${scrolled ? "scrolled" : ""}`}>
        <div className="header-container">

          {/* Logo */}
          <Link to="/" className="header-logo animate-pulse-custom">
            <div className="logo-3d-container">
              <img
                src={theme === "light" ? logo2 : logo2}
                alt="DOR Dress On Rent"
                className="logo-image"
              />
            </div>
          </Link>

          <div className="header-nav-wrapper">

            {/* Desktop Navigation */}
            <nav className="desktop-nav">

              <Link to="/#men" className="nav-link group">
                Men
                <span className="nav-link-underline"></span>
              </Link>

              <Link to="/#women" className="nav-link group">
                Women
                <span className="nav-link-underline"></span>
              </Link>

              <Link to="/#stores-location" className="nav-link group">
                Stores Location
                <span className="nav-link-underline"></span>
              </Link>

              <Link
                onClick={() => setShowEarnModal(true)}
                className="nav-link group"
              >
                Share Your Wardrobe
                <span className="nav-link-underline"></span>
              </Link>

              <Link to="/#contact" className="nav-link group">
                Contact Us
                <span className="nav-link-underline"></span>
              </Link>

              <Link to="/partner" className="nav-link group">
                Franchise
                <span className="nav-link-underline"></span>
              </Link>

              <Link to="/blog" className="nav-link group">
                Blog
                <span className="nav-link-underline"></span>
              </Link>


              {/* Theme Toggle */}
              <button
  onClick={handleChangeStore}
  className="nav-link group store-switch-btn"
  style={{
    background: "none",
    border: "none",
    cursor: "pointer"
  }}
>
  {selectedStore || "Change Store"}
  <span className="nav-link-underline"></span>
</button>

              {/* CTA */}
             <a
  href={`https://wa.me/918698797007?text=Hi,%20I%20want%20to%20rent%20an%20outfit%20from%20DOR%20${selectedStore}`}
  target="_blank"
  rel="noopener noreferrer"
  className="cta-button"
>
  Rent Now
  <ChevronRight size={18} className="icon-right" />
</a>
            </nav>

            {/* Mobile Menu Button */}
           <div className="mobile-header-actions">

  {/* Store Switch */}
  <button
    onClick={handleChangeStore}
    className="mobile-store-switch"
  >
    {selectedStore || "Store"}
  </button>

  {/* Mobile Menu Button */}
  <button
    className={`mobile-menu-button ${
      isMobileMenuOpen ? "rotate-90" : ""
    }`}
    onClick={toggleMobileMenu}
  >
    <Menu size={28} />
  </button>

</div>

          </div>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="mobile-nav">
            <ul className="mobile-nav-list">

              <li>
                <Link
                  to="/#men"
                  className="mobile-nav-item"
                  onClick={toggleMobileMenu}
                >
                  Men's Collection
                </Link>
              </li>

              <li>
                <Link
                  to="/#women"
                  className="mobile-nav-item"
                  onClick={toggleMobileMenu}
                >
                  Women's Collection
                </Link>
              </li>

              <li>
                <Link
                  to="/#stores-location"
                  className="mobile-nav-item"
                  onClick={toggleMobileMenu}
                >
                  Our Stores Location
                </Link>
              </li>

              <li>
                <Link
                  to="/#contact"
                  className="mobile-nav-item"
                  onClick={toggleMobileMenu}
                >
                  Contact Us
                </Link>
              </li>

              <li>
                <Link
                  to="/blog"
                  className="mobile-nav-item"
                  onClick={toggleMobileMenu}
                >
                  Blog
                </Link>
              </li>
              <li>
  <button
    className="mobile-nav-item"
    onClick={() => {
      handleChangeStore();
      toggleMobileMenu();
    }}
    style={{
      background: "none",
      border: "none",
      width: "100%",
      textAlign: "left"
    }}
  >
    {selectedStore || "Change Store"}
  </button>
</li>

              <li>
                <Link
                  onClick={() => {
                    setShowEarnModal(true);
                    toggleMobileMenu();
                  }}
                  className="mobile-nav-item"
                >
                  Share Your Wardrobe
                </Link>
              </li>

              

              <li>
                <Link
                  to="/partner"
                  className="mobile-nav-item"
                >
                  Franchise
                </Link>
              </li>

            </ul>
          </nav>
        )}
      </header>
    </>
  );
}

export default Header;